























































import { Component, Vue } from "vue-property-decorator";
import OkModal from "@/components/OkModal.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import firebase from "firebase/app";
import "firebase/auth";
import UserService from "@/services/UserService";

@Component({
  name: "SettingDeactivateApp",
  components: {
    ConfirmModal,
    OkModal,
  },
})
export default class SettingDeactivateApp extends Vue {
  message = "";
  isProcessing = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  get pMessage(): string {
    const message =
      "サービスを購入されている場合\n" +
      "・まだ未使用のサービスがないか、購入したサービス一覧でご確認ください。\n" +
      "・未使用のサービスがある状態で退会をされると、そのサービスは使用することができません。\n\n" +
      "下記へのアクセスが行えなくなります\n" +
      "・購入したサービス一覧ページ\n" +
      "・購入したサービス詳細ページ\n" +
      "・その他ログインを必要とするページ";
    return message;
  }

  openUseConfirmModal() {
    this.refs.useConfirmModal.open();
  }

  async deactivate() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    await UserService.leaveService()
      .then(() => {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.$store.commit("clearAuthState");
            localStorage.uid = "";
            localStorage.profileInput = "false";
            localStorage.userName = "";
            window.location.href = "/signup";
          });
      })
      .catch(() => {
        this.refs.errorModal.open();
      });
    this.isProcessing = false;
  }

  public mounted() {
    document.title = "退会確認 | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "退会確認 | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
  }
}
